import { serviceQuestionModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    serviceQuestionsToAdd: [],
    serviceId: 0
}

export default function serviceQuestionModalSlice(state = initialState, action) {
    switch (action.type) {
        case serviceQuestionModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case serviceQuestionModalSliceDispatch.setServiceQuestionsToAdd: {
            return {
                ...state,
                serviceQuestionsToAdd: action.payload
            }
        }
        case serviceQuestionModalSliceDispatch.setQuestionsToShow: {
            return {
                ...state,
                questionsToShow: action.payload
            }
        }
        case serviceQuestionModalSliceDispatch.setServiceId: {
            return {
                ...state,
                serviceId: action.payload
            }
        }
        default:
            return state
    }
}
